import { call, put, takeEvery } from "redux-saga/effects";
import {
  appointmentActionPatchError,
  appointmentActionPatchSuccess,
  appointmentAvailabilityPostError,
  appointmentAvailabilityPostSuccess,
  appointmentPostError,
  appointmentPostSuccess,
  executiveListGetError,
  executiveListGetSuccess,
  getAppointmentActionError,
  getAppointmentActionSuccess,
  getAppointmentError,
  getAppointmentSuccess,
} from "./actions";
import {
  appointmentAvailabilityPost,
  getAppointment,
  getAppointmentAction,
  getExecutiveList,
  patchAppointmentAction,
  postAppointment,
} from "../../resources/helper/appointment";

import {
  APPOINTMENT_POST,
  APPOINTMENTACTION_PATCH,
  APPOINTMENTAVAILABILITY_POST,
  EXECUTIVELIST_GET,
  GET_APPOINTMENT,
  GET_APPOINTMENT_ACTION,
} from "./actionTypes";

function* Appointment({ payload: { appointment } }) {
  try {
    const response = yield call(getAppointment, appointment.quoteId);
    yield put(getAppointmentSuccess(response));
  } catch (error) {
    yield put(getAppointmentError(error));
  }
}

function* AppointmentAction({ payload: { appointment } }) {
  try {
    const response = yield call(
      getAppointmentAction,
      appointment.appointmentId,
    );
    yield put(getAppointmentActionSuccess(response));
  } catch (error) {
    yield put(getAppointmentActionError(error));
  }
}

function* AppointmentActionPatch({
  payload: { appointmentActionBody, appointmentId },
}) {
  try {
    const response = yield call(
      patchAppointmentAction,
      appointmentActionBody,
      appointmentId,
    );
    yield put(appointmentActionPatchSuccess(response));
  } catch (error) {
    yield put(appointmentActionPatchError(error));
  }
}

function* executiveList({ payload: { executiveListBody } }) {
  try {
    const response = yield call(
      getExecutiveList,
      true,
      1,
      100,
      executiveListBody.roles,
    );
    yield put(executiveListGetSuccess(response));
  } catch (error) {
    yield put(executiveListGetError(error));
  }
}

function* appointmentAvailability({
  payload: { appointmentAvailabilityBody },
}) {
  try {
    const response = yield call(
      appointmentAvailabilityPost,
      appointmentAvailabilityBody,
    );
    yield put(appointmentAvailabilityPostSuccess(response));
  } catch (error) {
    yield put(appointmentAvailabilityPostError(error));
  }
}

function* appointmentPost({ payload: { appointmentBody } }) {
  try {
    const response = yield call(postAppointment, appointmentBody);
    yield put(appointmentPostSuccess(response));
  } catch (error) {
    yield put(appointmentPostError(error));
  }
}

function* AppointmentSaga() {
  yield takeEvery(GET_APPOINTMENT, Appointment);
  yield takeEvery(GET_APPOINTMENT_ACTION, AppointmentAction);
  yield takeEvery(APPOINTMENTACTION_PATCH, AppointmentActionPatch);
  yield takeEvery(EXECUTIVELIST_GET, executiveList);
  yield takeEvery(APPOINTMENTAVAILABILITY_POST, appointmentAvailability);
  yield takeEvery(APPOINTMENT_POST, appointmentPost);
}

export default AppointmentSaga;
